import type { MaybeType } from "@/shared/types";
import type {
  CalculatePriceResponse,
  PaymentPlan,
  SelectedTariffOption,
  Tariff,
} from "@/services/api/entities/payment/types";

export enum PaymentType {
  SAAS = "SaaS",
  ON_PREM = "OnPrem",
}

export enum PlansIds {
  SAAS_6_MONTHS = "SaaS.6",
  SAAS_1_YEAR = "SaaS.12",
  ON_PREM_6_MONTHS = "OnPrem.6",
  ON_PREM_1_YEAR = "OnPrem.12",
}

export type PlanList = Record<PlansIds, PaymentPlan>;

export interface PaymentState {
  idempotenceKey: MaybeType<string>;
  paymentOperationId: string;
  checkPaymentPolling: boolean;
  checkPaymentRetryCount: number;
  flowType: MaybeType<FlowType>;
  selectedTariff: MaybeType<Tariff>;
  selectedTariffOptions: SelectedTariffOption[];
  discountCode?: string;
  priceCalculation: MaybeType<CalculatePriceResponse>;
  paymentUrlHasError: boolean;
  paymentUrl: MaybeType<string>;
}

export enum FlowType {
  SIGN_UP = "signUp",
  UPDATE_SUBSCRIPTION = "updateSubscription",
  MOBILE_PAYMENT = "mobilePayment",
}
